/**
 * Token / 用户信息 / 菜单的本地存储管理
 *
 * Key 命名前缀使用项目名（api_platform），避免与其他系统在同一域名下冲突。
 */
const TOKEN_KEY = 'api_platform_token'
const USER_KEY = 'api_platform_user'
const MENUS_KEY = 'api_platform_menus'

/** 读取 token */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

/** 设置 token */
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

/** 清除登录态（token + user + menus + 权限缓存） */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(MENUS_KEY)
  // 修复：权限缓存未清，登出/401 后残留上一账号权限（换号登录窗口期越权显示）
  clearPermissionCache()
}

/** 读取当前用户信息 */
export function getUser() {
  const s = localStorage.getItem(USER_KEY)
  return s ? JSON.parse(s) : null
}

/** 设置当前用户信息 */
export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

/** 读取当前用户菜单树 */
export function getMenus() {
  const s = localStorage.getItem(MENUS_KEY)
  return s ? JSON.parse(s) : []
}

/** 设置当前用户菜单树 */
export function setMenus(menus) {
  localStorage.setItem(MENUS_KEY, JSON.stringify(menus))
}

// ==================== 权限校验 ====================

// 权限缓存（避免每次 hasPermission 都 JSON.parse + 递归）
let _permissionCache = null

/** 重建权限缓存（登录/登出/菜单变更后调用） */
export function rebuildPermissionCache() {
  const perms = new Set()

  // 优先从登录返回的 permissions 数组构建
  const user = getUser()
  if (user && Array.isArray(user.permissions)) {
    user.permissions.forEach((p) => perms.add(p))
  }

  // 再从菜单树补充（覆盖菜单上有但 permissions 数组没返回的）
  const menus = getMenus()
  function collect(items) {
    if (!items) return
    for (const item of items) {
      if (item.permission) perms.add(item.permission)
      if (item.children) collect(item.children)
    }
  }
  collect(menus)
  _permissionCache = perms
}

/** 清除权限缓存 */
export function clearPermissionCache() {
  _permissionCache = null
}

/**
 * 检查当前用户是否拥有指定权限
 * @param {string} perm 权限标识，如 'merchant:list'
 * @returns {boolean}
 */
export function hasPermission(perm) {
  if (!perm) return true
  if (!_permissionCache) rebuildPermissionCache()
  return _permissionCache.has(perm)
}
